import { Truck, ShieldCheck, MapPin, CreditCard } from 'lucide-react';
import { useEffect, useState } from 'react';
import api from '@/lib/api';

const badges = [
    { icon: MapPin, text: 'Ships from Abuja', sub: 'Wuse 2, FCT' },
    { icon: Truck, text: 'Fast Delivery', sub: 'Across Nigeria' },
    { icon: ShieldCheck, text: '100% Authentic', sub: 'Genuine Products' },
    { icon: CreditCard, text: 'Secure Payment', sub: 'Paystack Protected' },
];

export function TrustBar() {
    return (
        <div className="bg-white border-y border-gray-100" data-testid="trust-bar">
            <div className="max-w-7xl mx-auto px-4 py-3 sm:py-4">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
                    {badges.map(({ icon: Icon, text, sub }) => (
                        <div key={text} className="flex items-center gap-2.5 sm:justify-center">
                            <div className="w-9 h-9 rounded-full bg-pink-50 flex items-center justify-center flex-shrink-0">
                                <Icon className="w-4 h-4 text-pink-600" />
                            </div>
                            <div>
                                <p className="text-xs sm:text-sm font-body font-semibold text-gray-900 leading-tight">{text}</p>
                                <p className="text-[10px] sm:text-xs font-body text-gray-400 leading-tight">{sub}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export function TrustSignals({ compact = false }) {
    if (compact) {
        return (
            <div className="space-y-2" data-testid="trust-signals-compact">
                <div className="flex items-center gap-2 text-sm font-body text-gray-600 bg-pink-50/60 rounded-lg p-2.5">
                    <MapPin className="w-4 h-4 text-pink-600 flex-shrink-0" />
                    <span>Ships from <strong>Abuja, FCT</strong> &middot; Fast delivery within Nigeria</span>
                </div>
                <div className="flex items-center gap-2 text-sm font-body text-gray-600 bg-green-50/60 rounded-lg p-2.5">
                    <ShieldCheck className="w-4 h-4 text-green-600 flex-shrink-0" />
                    <span>100% authentic products &middot; Verified by BeautyByChancy</span>
                </div>
            </div>
        );
    }
    return (
        <div className="grid grid-cols-2 gap-2" data-testid="trust-signals">
            {badges.map(({ icon: Icon, text, sub }) => (
                <div key={text} className="flex items-center gap-2 bg-gray-50 rounded-lg p-2.5">
                    <Icon className="w-4 h-4 text-pink-600 flex-shrink-0" />
                    <div>
                        <p className="text-xs font-body font-semibold text-gray-800">{text}</p>
                        <p className="text-[10px] font-body text-gray-400">{sub}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

export function ReturnPolicy() {
    const [cfg, setCfg] = useState({
        summary: 'We accept returns within 7 days of delivery for unopened products in original packaging. Damaged or incorrect items can be returned at no extra cost. Contact us via WhatsApp to initiate a return.',
        days: 7,
    });
    useEffect(() => {
        api.get('/settings').then(({ data }) => {
            if (data?.return_policy_summary || data?.return_policy_days) {
                setCfg(c => ({
                    summary: data.return_policy_summary || c.summary,
                    days: data.return_policy_days || c.days,
                }));
            }
        }).catch(() => {});
    }, []);
    return (
        <div className="bg-amber-50/60 border border-amber-100 rounded-xl p-3 sm:p-4" data-testid="return-policy">
            <h4 className="text-sm font-body font-semibold text-amber-800 mb-1">Return Policy</h4>
            <p className="text-xs font-body text-amber-700 leading-relaxed" data-testid="return-policy-summary">
                {cfg.summary}
            </p>
        </div>
    );
}
